module.exports = __webpack_public_path__ + "static/media/0520-s-l.f5152ebe.png";